export enum SiteClusterSelection {
  CLUSTERS = 'CLUSTERS',
  SITES = 'SITES',
}
